var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_9_",
    "data-name": "search (9)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.424,
    height: 15.424,
    viewBox: "0 0 15.424 15.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2829",
    "data-name": "Group 2829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18908",
    "data-name": "Path 18908",
    d: "M6.955,0a6.952,6.952,0,0,1,5.887,10.656l2.128,2.128a1.546,1.546,0,1,1-2.186,2.186l-2.128-2.128A6.955,6.955,0,1,1,6.955,0Zm0,12.366a5.41,5.41,0,1,0-5.41-5.41A5.416,5.416,0,0,0,6.955,12.366Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.75aa62f60d0728ddc3f734a153583f6f.svg";
export { ForwardRef as ReactComponent };